module.exports = __webpack_public_path__ + "static/media/fdre_logo.1c93cb6f.png";